import { ref } from 'vue'

const isOnline = ref(navigator.onLine)
const wasOffline = ref(false)

let listeners: (() => void)[] = []

function setup() {
  const onOnline = () => {
    wasOffline.value = isOnline.value === false
    isOnline.value = true
  }
  const onOffline = () => {
    isOnline.value = false
  }

  window.addEventListener('online', onOnline)
  window.addEventListener('offline', onOffline)

  listeners = [
    () => window.removeEventListener('online', onOnline),
    () => window.removeEventListener('offline', onOffline),
  ]
}

setup()

export function useNetwork() {
  return { isOnline, wasOffline }
}

export function cleanupNetwork() {
  listeners.forEach(fn => fn())
}
